var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"actuality-modal",attrs:{"title":_vm.data.title,"hide-footer":"","body-bg-variant":"gray-lighten"},on:{"hidden":function($event){return _vm.close()}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.ctaContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }